//@ts-nocheck
/**
 * @file 工具集
 * @author Fanjinliang(fanjinliang@baidu.com)
 */

import React from 'react';
import { ToolSet } from '../../types';
import { Col, Button, Row } from 'antd';
import A from '../../../../components/a/A';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';

// todo: 替换图片
// import bg from '../../../paddlegan2/image/bg_02.jpg';
interface IProps {
    toolSet: ToolSet;
}

const PaddleNlpToolset: React.FC<IProps> = props => {
    const {
        // todo: 最好从bthLink改成btnLink
        toolSet: { desc, btnWord, bthLink, code }
    } = props;

    return (
        <Row className="toolset-container">
            <Col span={12}>
                <div className="toolset-desc">{desc}</div>
                <A href={bthLink} target={'_blank'}>
                    <Button className="paddle-paddle-page-banner-btn toolset-btn" type="primary" size="large">
                        {btnWord}
                    </Button>
                </A>
            </Col>
            {/* todo:  替换图片*/}
            <Col span={10}>
                {!!code && (
                    <div className="toolset-img">
                        <div className="code-wrapper">
                            <SyntaxHighlighter language="python" style={a11yDark}>
                                {code.content.replace(/\\n/g, '\n')}
                            </SyntaxHighlighter>
                        </div>
                    </div>
                )}
            </Col>
        </Row>
    );
};

export default PaddleNlpToolset;
